import GDPRButton from './GDPRButton';
import './GDPRButton.scss';

export default GDPRButton;
